import Footer from "components/Footers/Footer";
import Navbar from "components/Navbars/AuthNavbar";
import React from "react";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { useEffect, useState } from "react";
import BASE_URL from "components/BaseUrl/apiConfig";

const ItemDetails = ({ location }) => {
  const history = useHistory();
  const [currency, setCurrency] = useState("");

  //get userid form loca storage
  const storedUserData = localStorage.getItem("userData");

  let groupId = "";
  if (storedUserData) {
    const userData = JSON.parse(storedUserData);
    groupId = userData.groupId;
  }

  useEffect(() => {
    // Check if user is not logged in (localStorage is empty)
    if (!localStorage.getItem("userData")) {
      // Redirect to the login page
      history.push("/login");
    }
  }, [history]);

  useEffect(() => {
    const fetchCurrencyData = async () => {
      try {
        const response = await fetch(
          `${BASE_URL}/api/Users/GetCurrencyByUserId?groupId=${groupId}`
        );
        const data = await response.json();
        // Assuming the API response has a property called 'currency'
        setCurrency(data.currency);
      } catch (error) {
        console.error("Error fetching currency data:", error);
      } finally {
      }
    };

    fetchCurrencyData();
  }, []);

  const { item } = location.state || {};

  return (
    <>
      <Navbar />
      <div className="cust-div" style={{ minHeight: "550px" }}>
        <div className="container mx-auto mt-8 p-4">
          <h2 className="text-2xl font-bold mb-4">Item Details</h2>
          {item ? (
            <div>
              <p>
                <strong>Item Name:</strong> {item.itemName}
              </p>
              <p>
                <strong>Item Cost/Unit({currency}):</strong> {item.itemCost}
              </p>
              <p>
                <strong>Description:</strong> {item.itemDescription}
              </p>
              <p>
                <strong>Default Text:</strong> {item.defaultText}
              </p>
              <p>
                <strong>Tab Order:</strong> {item.tabOrder}
              </p>
              <p>
                <strong>Color:</strong> {item.color}
              </p>

              {/* Add other user details as needed */}
            </div>
          ) : (
            <p>No item available.</p>
          )}
          <button
            type="button"
            className="bg-lightBlue-500 text-white active:bg-lightBlue-600 text-xs font-bold uppercase px-4 py-2 mt-4 rounded shadow hover:shadow-lg outline-none focus:outline-none ease-linear transition-all duration-150"
            onClick={() => history.goBack()}
          >
            Cancel
          </button>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default ItemDetails;
